import React from 'react'
import { Field } from 'formik'
import styled from 'styled-components'
import { User } from '@graphics/gfx-common/dist/types'
import { UserDateType } from '../../types/date'
import * as date from '../../services/date'
import { Space } from '../../layouts'
import { LabeledChip } from '../LabeledChip'
import { CustomTextField } from '../CustomTextField'

export const StyledDateFieldsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  div {
    margin-right: 24px;
  }
`

interface IDateAuthorFragment extends UserDateType {
  user: User
}

export const DateAuthorFragment = ({
  created,
  createdBy,
  modified,
  modifiedBy,
  user,
}: IDateAuthorFragment) => (
  <StyledDateFieldsWrapper>
    <div>
      <Space mb={4}>
        <LabeledChip label="Created by">
          {(createdBy && createdBy.name) || user.name}
        </LabeledChip>
      </Space>
      <Field
        name="created"
        label="Created Date"
        component={CustomTextField}
        disabled
        value={date.format(created || new Date().toISOString(), 'SHORT')}
      />
    </div>
    {modified && modifiedBy && (
      <div>
        <Space mb={4}>
          <LabeledChip label="Modified by">
            {(modifiedBy && modifiedBy.name) || user.name}
          </LabeledChip>
        </Space>
        <Field
          name="modified"
          label="Modified Date"
          component={CustomTextField}
          disabled
          value={date.format(modified || new Date().toISOString(), 'SHORT')}
        />
      </div>
    )}
  </StyledDateFieldsWrapper>
)
